// extracted by mini-css-extract-plugin
module.exports = {"Card":"style_Card__15pIN","Marck":"style_Marck__3VHMs","Wrapper":"style_Wrapper__1t3O-","Content":"style_Content__36nb9","Text":"style_Text__1-ewh","Result":"style_Result__1G5dn"};